import AdminCataloguePackageForm from './AdminCataloguePackageForm';

export default AdminCataloguePackageForm;
